import { render, staticRenderFns } from "./department.vue?vue&type=template&id=58a50e43&"
import script from "./department.vue?vue&type=script&lang=js&"
export * from "./department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a50e43')) {
      api.createRecord('58a50e43', component.options)
    } else {
      api.reload('58a50e43', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=58a50e43&", function () {
      api.rerender('58a50e43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cascader/department.vue"
export default component.exports